import { getTokenDeliveryMode } from '@digiwedge/idp-client';
import { storage } from './storage.js';
function clearStoredTenantContexts() {
    storage.removeItem('tenantClub');
    storage.removeItem('crmTenant');
}
export const createAuthSlice = (set) => ({
    isAuthenticated: false,
    token: null,
    refreshToken: null,
    jti: null,
    authBootStatus: 'pending',
    login: (accessToken, refreshToken, jti, remember = false) => {
        const cookieOnly = getTokenDeliveryMode() === 'cookie';
        clearStoredTenantContexts();
        if (cookieOnly) {
            storage.removeItem('accessToken');
            storage.removeItem('refreshToken');
            storage.removeItem('jti');
        }
        else {
            // Async write to storage
            storage.setItem('accessToken', accessToken, remember);
            if (refreshToken)
                storage.setItem('refreshToken', refreshToken, remember);
            if (jti)
                storage.setItem('jti', jti, remember);
        }
        // Immediately update in-memory store
        const nextState = {
            isAuthenticated: true,
            token: accessToken || null,
            refreshToken: refreshToken || null,
            jti: jti || null,
            authBootStatus: 'ok',
            tenantClub: null,
            crmTenant: null,
        };
        set(nextState);
    },
    setAuthenticated: () => {
        clearStoredTenantContexts();
        if (getTokenDeliveryMode() === 'cookie') {
            storage.removeItem('accessToken');
            storage.removeItem('refreshToken');
            storage.removeItem('jti');
        }
        const nextState = {
            isAuthenticated: true,
            token: null,
            refreshToken: null,
            jti: null,
            authBootStatus: 'ok',
            tenantClub: null,
            crmTenant: null,
        };
        set(nextState);
    },
    setAuthBootStatus: (status) => {
        set({ authBootStatus: status });
    },
    logout: () => {
        // Async remove
        storage.removeItem('accessToken');
        storage.removeItem('refreshToken');
        storage.removeItem('jti');
        clearStoredTenantContexts();
        const nextState = {
            isAuthenticated: false,
            token: null,
            refreshToken: null,
            jti: null,
            authBootStatus: 'unauthenticated',
            tenantClub: null,
            crmTenant: null,
        };
        set(nextState);
    },
});
//# sourceMappingURL=authSlice.js.map